// Paddle Price ID Mapping
// Exact IDs from @docs/paywall/paddle-prices.js
import { getEnvironmentTier } from '../utils/environment';

export const PADDLE_PRICES_MAP = {
  sandbox: {
    // 3-Month plans
    "com.shamruk.velvet.3m80f12w": "pri_01k7htkafr68bxmqc2pmqp4rvt", // 3 months $80 after 12 week trial
    "com.shamruk.velvet.3m80f3m": "pri_01k7h3smvhgwh21arzk9ra85aj", // 3 months $80 after 3 months

    // Monthly plans
    "com.shamruk.velvet.m50f1m": "pri_01k7h3r4rm3p6a1z8z9s46tgsm", // Monthly $50 after 1 month
    "com.shamruk.velvet.m50f1w": "pri_01k7h537f6wwcb3ax75d84t418", // Monthly $50 after 1 week trial
    "com.shamruk.velvet.m50f4w": "pri_01k7htfn36e3c4d5vm64cen6pm", // Monthly $50 after 4 week trial

    // One-time trial prices
    "com.shamruk.velvet.one1": "pri_01k7h50abpmy0qvx3fvy6cg85y", // One-time payment $0.99
    "com.shamruk.velvet.one2": "pri_01k7h50np8qtat4p3zny8q46ct", // One-time payment $1.99
    "com.shamruk.velvet.one4": "pri_01k7h4z1thdw2m877r94mftd6b", // One-time payment $3.99
    "com.shamruk.velvet.one7": "pri_01k7h4zjb91emw7emewv3hqsfp", // One-time payment $6.99
    "com.shamruk.velvet.one10": "pri_01k7h4y3yvkavjv8bdacaxk2h9", // One-time payment $9.99
    "com.shamruk.velvet.one15": "pri_01k7h4xg4tjh04x0ajr2w1ad5g", // One-time payment $14.99

    // Annual plans
    "com.shamruk.velvet.y40": "pri_01k6xs27whpnq6x8p5pyy127xz", // Annual plan - $39.99
  },
  production: {
    // 3-Month plans
    "com.shamruk.velvet.3m80f12w": "pri_01k7j5gf04pkt0z50jm85r2ch9", // 3 months $80 after 12 week trial
    "com.shamruk.velvet.3m80f3m": "pri_01k7j5ggxr6wc66ffp2wy330y2", // 3 months $80 after 3 months

    // Monthly plans
    "com.shamruk.velvet.m50f1m": "pri_01k7j5gh3f7nx68emy5581jmhr", // Monthly $50 after 1 month
    "com.shamruk.velvet.m50f1w": "pri_01k7j5gff28skmbyh102cd9rdh", // Monthly $50 after 1 week trial
    "com.shamruk.velvet.m50f4w": "pri_01k7j5gf5x8v1m7156t1y3m0dm", // Monthly $50 after 4 week trial

    // One-time trial prices
    "com.shamruk.velvet.one1": "pri_01k7j5gfxqyyn6q3ezg3gs28rp", // One-time payment $0.99
    "com.shamruk.velvet.one2": "pri_01k7j5gfqtzpamb9tcfajnb82d", // One-time payment $1.99
    "com.shamruk.velvet.one4": "pri_01k7j5gga4a5vxpg8phd5nghmd", // One-time payment $3.99
    "com.shamruk.velvet.one7": "pri_01k7j5gg3j31ar2w28w6fq3nha", // One-time payment $6.99
    "com.shamruk.velvet.one10": "pri_01k7j5ggg5arkc8hj46m4jzf8f", // One-time payment $9.99
    "com.shamruk.velvet.one15": "pri_01k7j5ggphhb7ytfj0q01gb1xz", // One-time payment $14.99

    // Annual plans
    "com.shamruk.velvet.y40": "pri_01k7j5gh9nq0nzgy8j52x015j2", // Annual plan - $39.99
    "com.shamruk.velvet.y60": "pri_01k7gxachszb34dbd0860r9r6d", // Annual plan - $59.99 original
  }
};

// Helper function to get current environment
export function getCurrentEnvironment() {
  return getEnvironmentTier();
}

// Helper function to get Paddle price ID for current environment
export function getPaddlePriceId(productId: string): string | null {
  const env = getEnvironmentTier();
  return PADDLE_PRICES_MAP[env]?.[productId] || null;
}

// Validate if all required price IDs are configured for current environment
export function validatePaddleConfiguration(requiredIds: string[]): {
  valid: boolean;
  missing: string[];
} {
  const missing: string[] = [];

  for (const id of requiredIds) {
    const priceId = getPaddlePriceId(id);
    if (!priceId) {
      missing.push(id);
    }
  }

  return {
    valid: missing.length === 0,
    missing
  };
}